import React, { useEffect, useState } from "react";
import "./Hero.scss";
import hero from "../../assets/images/Hero2.png";
import { motion, useTransform, useViewportScroll } from "framer-motion";

function Hero() {
  // const [delay, setdelay] = useState(0.05);
  // useEffect(() => {
  //   if ( window.innerWidth < 991) {
  //     setdelay(0);
  //   } else {
  //     setdelay(0.05);
  //   }
  //   window.addEventListener("resize", () => {
  //     if ( window.innerWidth < 991) {
  //       setdelay(0);
  //     } else {
  //       setdelay(0.05);
  //     }
  //   });
  // });
  // const { scrollYProgress } = useViewportScroll();
  // const scale = useTransform(scrollYProgress, [0, delay], [0.9, 1]);
  return (
    <section className="hero">
      <div className="container">
        <div className="heroimage">
          <img src={hero} alt="" loading="lazy" />
        </div>
        <div className="hero-container">
          <motion.div className="hero-text-outer">
            <div className="herotext">
              <h1 className="hero-heading upheav">The new Rules of the Game</h1>
              <p className="hero-subheading retro">
                IndiGG is a movement to bring the Best of <br /> Web3’s gaming,
                to India.
              </p>
              <div className="press">Press START to apply</div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
